import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[allowDecimal]'
})
export class AllowDecimalDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const initialValue = this.el.nativeElement.value;

    // 1. Replace any character that is not a digit or a dot.
    let newValue = initialValue.replace(/[^0-9.]/g, '');

    // 2. Ensure that there is only one decimal point.
    const parts = newValue.split('.');
    if (parts.length > 2) {
      // If more than one dot is present, reconstruct the string
      // using the first part, a dot, and the rest joined together.
      newValue = parts[0] + '.' + parts.slice(1).join('');
    }

    // 3. Update the element's value if it has been changed.
    if (initialValue !== newValue) {
      this.el.nativeElement.value = newValue;
      event.stopPropagation();
    }
  }
}
